module.exports = __webpack_public_path__ + "static/img/trap-master.52f7ec5.svg";